import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage/session";

import authentication from "./authentication.reducer";
import steps from "./steps.reducer";
import crm from "./crm.reducer";
import room from "./room.reducer";

const rootPersistConfig = {
  key: "root",
  storage: storage,
  blacklist: [],
};

const authPersistConfig = {
  key: "auth",
  storage: storage,
  blacklist: ["isLoggingIn"],
};

export default combineReducers({
  authentication: persistReducer(authPersistConfig, authentication),
  steps,
  crm,
  room,
});
